<div class="relative md:rounded-lg md:border border-default flex flex-col flex-1 min-h-0 overflow-hidden text-sm text-gray-500 dark:text-gray-400">
  <cdk-virtual-scroll-viewport [itemSize]="resultTableService.itemSize()" class="flex-1 min-h-0" id="results-viewport">
    <div class="hidden md:grid shrink-0 text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400 border-b border-default gap-4"
         id="results-table-header"
         style="grid-template-columns: var(--result-cols);">
      @for (column of resultTableService.columns; track $index) {
        <app-results-table-header-column [column]="column"></app-results-table-header-column>
      }
    </div>

    @if (resultTableService.allRows().length === 0) {
      <div class="text-center py-4">No Results</div>
    }
    <app-results-table-row
      *cdkVirtualFor="let item of resultTableService.allRows(); trackBy: trackByItem"
      [item]="item"
      [class.!bg-brand-soft]="resultsStore.isInCompare()(item)"
      class="leading-tight result-item">
    </app-results-table-row>
  </cdk-virtual-scroll-viewport>

  <div class="absolute bottom-10 right-2 z-10 transition-opacity duration-300" [class.opacity-0]="!showScrollToTop()" [class.pointer-events-none]="!showScrollToTop()">
    <app-button size="small" variant="secondary" (click)="scrollToTop()" title="Scroll to top">
      <app-icons icon="arrow-up"/>
    </app-button>
  </div>

  <div class="flex items-center h-8 px-2 py-1 border-t not-md:border not-md:rounded-b-lg border-default">
    <span class="text-sm text-gray-700 dark:text-gray-400">
      <span class="font-semibold text-gray-900 dark:text-white">{{ resultTableService.totalFilteredItems() }}</span> results
    </span>
  </div>
</div>

@if (resultTableService.selectedItem(); as item) {
  <app-results-item-details-modal [item]="item" [isOpen]="resultTableService.activeModal() === 'details'" (isOpenChange)="resultTableService.closeModal()">
    <div actions class="space-x-2">
      @if (resultsStore.isInCompare()(item)) {
        <app-button variant="danger" size="small" (click)="resultTableService.removeFromCompare(item)">
          <app-icons icon="circle-x"/>
          Remove
        </app-button>
      } @else {
        <app-button size="small" variant="secondary" (click)="resultTableService.addToCompare(item)">
          <app-icons icon="arrow-left-arrow-right"/>
          Compare
        </app-button>
      }
      <app-button size="small" (click)="resultTableService.addToQuote(item)">
        <app-icons icon="add-column-before"/>
        Add To Quote
      </app-button>
    </div>
  </app-results-item-details-modal>

  <app-results-item-supplier-selection-modal [item]="item" [isOpen]="resultTableService.activeModal() === 'supplier'" (isOpenChange)="resultTableService.closeModal()" (itemSelected)="resultTableService.handleSupplierSelected($event)"/>
}
